import { cva } from 'class-variance-authority';

export const containerVariants = cva(
    'w-full relative rounded-lg border px-3 py-2 focus-within:border-primary-500 bg-transparent text-base font-medium transition-all duration-200',
    {
        variants: {
            variant: {
                default: 'border-gray-200 focus-within:border-primary-500',
                error: 'border-red-500 focus-within:border-red-500'
            },
            size: {
                sm: 'min-h-[3rem]',
                default: 'min-h-[4rem]',
                lg: 'min-h-[5rem]'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
);

export const floatingLabelVariants = cva(
    'absolute right-3 text-gray-500 transition-all duration-200 pointer-events-none bg-white px-1',
    {
        variants: {
            variant: {
                default: 'peer-focus:text-primary-500',
                error: 'text-red-500 peer-focus:text-red-500'
            },
            size: {
                sm: 'top-2 peer-focus:-top-2 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-2 peer-[:not(:placeholder-shown)]:text-xs',
                default:
                    'top-3 peer-focus:-top-2 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-2 peer-[:not(:placeholder-shown)]:text-xs',
                lg: 'top-4 peer-focus:-top-2 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-2 peer-[:not(:placeholder-shown)]:text-xs'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
);

